import { boot } from 'quasar/wrappers';
import { LOCALSTORAGE } from 'src/composables/const';
import { useUserStore } from 'src/store/userStore';

export default boot(async ({}) => {
  const user = useUserStore();
  const jwt = localStorage.getItem(LOCALSTORAGE.TOKEN);

  if (jwt && jwt.length) {
    user.setToken(jwt);
  }
  await user.getMe();
});
